module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEWAQMAAADmUjj9AAAAA1BMVEV/f/99cpgDAAAAAXRSTlMavYQhHAAAACBJREFUaEPtwQEBAAAAgJD+r+4ICgAAAAAAAAAAAACqBipaAAEsU9uqAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ../components/default-pic.png
 ** module id = 1301
 ** module chunks = 0
 **/